import {
  APP_TYPES_API_SUBSTITUTES,
  APP_TYPES_DISPLAY_SUBSTITUTES,
} from 'resources/APP_TYPES_DISPLAY_SUBSTITUTES'
import { TAppTypesDisplaySubsitutes, TAppTypesApiSubstitutes } from 'types/apps'

export const convertApiAppNameToDisplay = (
  name: TAppTypesApiSubstitutes
): TAppTypesDisplaySubsitutes => {
  return APP_TYPES_DISPLAY_SUBSTITUTES[name] ?? ''
}
export const convertDisplayAppNameToApi = (
  name: TAppTypesDisplaySubsitutes
): TAppTypesApiSubstitutes => {
  return APP_TYPES_API_SUBSTITUTES[name] ?? ''
}
